import { useController } from "react-hook-form";
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Check, Square } from "@mui/icons-material";

import { COLOR } from "config/color";

export default function RadioButtonGroup({
  helperText,
  options,
  label,
  name,
  parseError,
  labelKey = "label",
  valueKey = "id",
  required,
  emptyOptionLabel,
  returnObject,
  row,
  control,
  defaultValue,
  ...rest
}) {
  const theme = useTheme();
  const {
    field: { value, onChange },
    fieldState: { invalid, error },
  } = useController({
    name,
    rules: required ? { required: "此為必填" } : undefined,
    control,
    defaultValue,
  });

  helperText = error
    ? typeof parseError === "function"
      ? parseError(error)
      : error.message
    : helperText;

  const onRadioChange = (event) => {
    const radioValue = event.target.value;
    const returnValue = returnObject
      ? options.find((items) => items[valueKey] === radioValue)
      : radioValue;
    // setValue(name, returnValue, { shouldValidate: true })
    onChange(returnValue);

    if (typeof rest.onChange === "function") {
      rest.onChange(returnValue);
    }
  };

  return (
    <FormControl error={invalid}>
      {label && (
        <FormLabel required={required} error={invalid}>
          {label}
        </FormLabel>
      )}
      <RadioGroup
        onChange={onRadioChange}
        name={name}
        row={row}
        value={value || ""}
      >
        {emptyOptionLabel && (
          <FormControlLabel
            control={
              <Radio
                sx={{
                  color: invalid ? theme.palette.error.main : undefined,
                }}
                checked={!value}
              />
            }
            label={emptyOptionLabel}
            value=""
          />
        )}
        {options.map((option) => {
          const optionKey = option[valueKey];
          if (!optionKey) {
            console.error(
              `CheckboxButtonGroup: valueKey ${valueKey} does not exist on option`,
              option
            );
          }
          const isChecked = !!(
            value &&
            (returnObject ? value[valueKey] === optionKey : value === optionKey)
          );

          return (
            <FormControlLabel
              control={
                <Radio
                  checkedIcon={
                    <Check
                      style={{
                        fill: COLOR.fontColorPrimary,
                        background: COLOR.btnBackground,
                      }}
                    />
                  }
                  iconStyle={{
                    width: "22px",
                    height: "22px",
                    marginRight: "10px",
                    paddingTop: "1px",
                  }}
                  icon={
                    <Square
                      style={{
                        background: COLOR.btnBackground,
                        fill: COLOR.btnBackground,
                      }}
                    />
                  }
                  sx={{
                    color: invalid ? theme.palette.error.main : undefined,
                  }}
                  checked={isChecked}
                />
              }
              value={optionKey}
              label={option[labelKey]}
              key={optionKey}
            />
          );
        })}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
